import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/app/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class AuditTrailServiceService {
  private auditUrl = `${environment.serverUrl}/api/v1/createAuditTrails`;  

  constructor(private http: HttpClient) {}

  logAuditTrail(payload: {
    user_id: number;
    module_name: string;
    action_type: 'CREATE' | 'UPDATE' | 'DELETE';
    previous_data: any;
    new_data: any;
  }) {
    return this.http.post(this.auditUrl, payload,{
      headers: new HttpHeaders({ 'X-Audit': 'true' })
    }); 
  }
  
}
